import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason  } from '@mui/material';
import { useState } from 'react';
import { IVFormErrors, VForm, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { RelatorioService } from '../../../shared/services/api/rh/Relatorios/RelatoriosService';
import * as XLSX from 'xlsx';
        
export const ExporteExcelSalarios: React.FC = () => {          
  const { formRef, save } = useVForm();
  const [isLoading, setIsLoading] = useState(false); 
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
          
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };      
              
  const handleSave = () => {                                  
    RelatorioService
      .ExportExcelSalarios()   
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {           
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else 
        {
          const workbook = XLSX.utils.book_new();
          const worksheet = XLSX.utils.json_to_sheet(result);
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Posts');
          XLSX.writeFile(workbook, 'salarios.xlsx');
        }
      }   
      )
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};   
        errors.inner.forEach(error => {   
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });            
  };    
  
  return (
    <VForm ref={formRef} onSubmit={handleSave}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box  alignItems="center" width='auto' alignContent='center' height="auto"  display="flex" flexDirection="column"  >
        <Box gap={1}  padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' alignContent='center'></Box>
        <Box   width='auto' alignItems="center"  component={Paper} height="auto" margin={1} 
          alignContent='center'>       
          <DialogTitle>Exportar Relação de Funcionários</DialogTitle>
          <DialogContent  dividers>    
            {isLoading && (           
              <Grid item>  
                <LinearProgress variant='indeterminate' />  
              </Grid>                      
            )}   
            <Grid container  padding={1} item direction="row" gap={2}>
              <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                 
                </Grid> 
              </Grid>        
            </Grid>         
          </DialogContent>     
          <DialogActions>
            <Button sx={{ minWidth:'30%'  }} variant='outlined' autoFocus onClick={save}>Visualizar</Button>
          </DialogActions>
        </Box>
      </Box>
    </VForm> 
  );
};   